import React from "react";
import PhoneNumberCopy from "../../../components/phoneNumberCopy/PhoneNumberCopy";
import EmailLink from "../../../components/emailLink/EmailLink";
import BlankProPic from "../../../styles/images/no-user-sm.png";


export function RenderFieldDetails({ fieldName, fieldArrayValues }: { fieldName: string, fieldArrayValues: any }) {
    return (<div className="position-absolute bg-white shadow w-100 pt-2" style={{
        right: 0,
        maxWidth: "435px",
        zIndex: 100
    }}>
        <div className="px-3 pt-2 font-normal text-gray-600 font-weight-semibold my-1">
            {fieldName}
        </div>
        {fieldArrayValues?.map((item: any, index: number) => {
            return <div className="d-flex align-items-center text-nowrap py-2 px-3 border-bottom" key={index}>
                <img src={item?.profileImage ? item?.profileImage : BlankProPic} alt="image_not_found" className="img-cover rounded-circle img-responsive mr-2" width={26} height={26} />
                <div className="font-weight-semibold">
                    <div className="font-normal">{item.contactName}</div>
                    <div className="font-xs text-gray-600 d-flex align-items-center">
                        {item.phones.map((itm: any, idx: number) => <>
                            <PhoneNumberCopy>{itm.phone}</PhoneNumberCopy>
                            {++idx < item?.phones?.length ? ", " : ""}
                        </>)}
                    </div>
                    <div className="font-xs text-gray-600 d-flex align-items-center">
                        {item.emails.map((itm: any, idx: number) => <>
                            <EmailLink>{itm.email}</EmailLink>
                            {++idx < item.emails.length ? ", " : ""}
                        </>)}
                    </div>
                    <div className="font-xs text-gray-600 d-flex align-items-center">
                        {item?.type}
                    </div>
                </div>
            </div>;
        })}
    </div>);
}